import React from 'react';
import { Badge } from './ui/badge';
import { Users } from 'lucide-react';

export default function GroupBadge({ group, showIcon = true }) {
  if (!group) {
    return null;
  }

  return (
    <Badge
      variant="outline"
      style={{
        borderColor: group.color || '#3b82f6',
        color: group.color || '#3b82f6',
        backgroundColor: `${group.color || '#3b82f6'}10`
      }}
      className="flex items-center gap-1"
    >
      {showIcon && <Users className="h-3 w-3" />}
      {group.name}
    </Badge>
  );
}
